module.exports = __webpack_public_path__ + "img/1x.fd53fa1.jpg";